

const validatorAcceptInputFileMixin = {
  methods: {
    validatorAcceptInputFile(schema, ItemValue, ) {
      if ('accept' in schema && ItemValue) {
        let items = [];

        Array.isArray(ItemValue) ? (items = ItemValue) : items.push(ItemValue);

        for (let item in items) {
          const acceptType = schema.accept.split(',');

          let acceptContains = false;

          for (let itemType in acceptType) {
            const emptyChar = acceptType[itemType].replace(/[^a-zA-Z0-9]+/g, '');

            let validInput = emptyChar == 'image' ? items[item].type.includes(emptyChar) : items[item].name.split('.')[1] == emptyChar;

            if (validInput) {
              acceptContains = true;
            }
          }

          if (!acceptContains) {
            //this.value = null;

            this.$store.dispatch('notification/showNotification', {
              color: 'error',
              text: 'Tipo do arquivo não é valido',
              showIconNotification: false
            });

            return true
          }
        }
      }
    }
  }
};

export default validatorAcceptInputFileMixin;